import React from 'react';
import { motion } from 'framer-motion';
const ARGENTINA_PATH = 'M150 8 L182 6 L196 30 L214 40 L236 44 L242 66 L238 86 L226 104 L232 124 L246 140 L240 168 L228 188 L232 208 L222 232 L214 256 L206 284 L196 312 L190 340 L178 368 L170 396 L160 424 L150 452 L140 480 L128 506 L120 532 L108 552 L96 566 L86 580 L74 590 L64 596 L58 586 L66 570 L74 548 L80 520 L86 492 L92 462 L96 430 L100 398 L104 366 L108 334 L106 302 L100 272 L94 244 L92 216 L96 188 L100 160 L104 132 L108 104 L112 76 L120 48 L132 24 Z';
const HUB = {
  x: 196,
  y: 245,
  name: 'Pergamino'
};
const NODES = [{
  x: 168,
  y: 62,
  name: 'Norte'
}, {
  x: 160,
  y: 105,
  name: 'Noroeste'
}, {
  x: 170,
  y: 200,
  name: 'Centro'
}, {
  x: 202,
  y: 226,
  name: 'Litoral'
}, {
  x: 208,
  y: 254,
  name: 'AMBA'
}, {
  x: 128,
  y: 215,
  name: 'Cuyo'
}, {
  x: 172,
  y: 300,
  name: 'Sur de Buenos Aires'
}, {
  x: 128,
  y: 302,
  name: 'Alto Valle'
}, {
  x: 130,
  y: 420,
  name: 'Patagonia central'
}, {
  x: 96,
  y: 520,
  name: 'Patagonia austral'
}, {
  x: 86,
  y: 572,
  name: 'Extremo sur'
}];
export function ArgentinaCoverageMap() {
  return <figure className="relative" data-id="element-37" data-mp="hb3qampmnqpb">
      <svg viewBox="0 0 300 620" role="img" aria-labelledby="mapa-cobertura-titulo" className="h-auto w-full max-w-[360px]" data-id="element-38" data-mp="h9skkhcmg8vk">
        <title id="mapa-cobertura-titulo" data-id="element-39" data-mp="v1gxgmup31dl">
          Mapa esquemático de Argentina con la red de cobertura de Rabemar y sus corredores operativos
        </title>
        <path d={ARGENTINA_PATH} fill="#0A3626" stroke="#1F7551" strokeWidth="1.5" data-id="element-40" data-mp="2ctb0ny7m5yg" />

        {NODES.map((node, i) => <motion.line key={`ruta-${node.name}`} x1={HUB.x} y1={HUB.y} x2={node.x} y2={node.y} stroke="#EEAE43" strokeWidth="1" strokeDasharray="3 4" initial={{
        pathLength: 0,
        opacity: 0
      }} whileInView={{
        pathLength: 1,
        opacity: 0.75
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.28,
        delay: i * 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-41" data-mp="3uiygcfpqsesp" data-mpi={i} />)}

        {NODES.map((node, i) => <motion.circle key={node.name} cx={node.x} cy={node.y} r="3.2" fill="#74AF93" initial={{
        scale: 0.96,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.2,
        delay: 0.15 + i * 0.04,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-42" data-mp="1uu46q4ttsqg2" data-mpi={i} />)}

        <circle cx={HUB.x} cy={HUB.y} r="9" fill="#DC9016" fillOpacity="0.22" data-id="element-43" data-mp="1c3miacg10h0i" />
        <circle cx={HUB.x} cy={HUB.y} r="4.5" fill="#EEAE43" data-id="element-44" data-mp="1c1jpjknho9s3" />
        <text x={HUB.x + 12} y={HUB.y + 4} fill="#FFFFFF" fontSize="11" fontWeight="600" data-id="element-45" data-mp="1h1xqyjul4lh5">
          {HUB.name}
        </text>
      </svg>
      <figcaption className="mt-4 text-xs leading-relaxed text-mist-300" data-id="element-46" data-mp="1lv904rmvdec8">
        Esquema de corredores operativos. Cobertura en todo el territorio argentino con flota propia y red 3PL.
      </figcaption>
    </figure>;
}